import { render } from "./UpdateLevel.vue?vue&type=template&id=fb9ab678&scoped=true"
import script from "./UpdateLevel.vue?vue&type=script&lang=js"
export * from "./UpdateLevel.vue?vue&type=script&lang=js"

import "./UpdateLevel.vue?vue&type=style&index=0&id=fb9ab678&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9ab678"]])

export default __exports__